import { render, staticRenderFns } from "./RSVP.vue?vue&type=template&id=655d43ad&scoped=true"
import script from "./RSVP.vue?vue&type=script&setup=true&lang=js"
export * from "./RSVP.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d43ad",
  null
  
)

export default component.exports